import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import "./Portfolio.css";

// 🔗 PLACEHOLDER: Replace null values with your portfolio image paths
// e.g. import img1 from '../assets/portfolio/item1.jpg'  then: image: img1
const PORTFOLIO_ITEMS = [
  {
    id: 1,
    title: "GLAMJAM Business Application Design",
    category: "Application Design",
    image: "/images/pproject1.jpeg",
    href: "https://www.behance.net/gallery/175943047/Freelance-App-UI-UX-Design",
  },
  {
    id: 2,
    title: "Product Design",
    category: "Application Design",
    image: "/images/pproject2.jpeg",
    href: "https://www.behance.net/gallery/212675345/Application-Design",
  },
  {
    id: 3,
    title: "MayaOptics E-Commerce Store",
    category: "Website Design",
    image: "/images/pproject3.jpeg",
    href: "https://www.behance.net/gallery/234849437/Ecommerce-Eye-wear-brands-Landing-Design-For-Shopify",
  },
  {
    id: 4,
    title: "Portfolio Website Design",
    category: "Website Design",
    image: "/images/pproject4.jpeg",
    href: "https://www.behance.net/gallery/213962349/Portfolio-Page-Design",
  },
  {
    id: 5,
    title: "Nescafe Chill Marketing Video",
    category: "Animation Video",
    image: "/images/pproject5.png",
    href: "https://www.behance.net/gallery/220473141/Nescafe-Chill-Marketing-Ads",
  },
  {
    id: 6,
    title: "2D Explainer Animation",
    category: "Animation Video",
    image: "/images/pproject6.png",
    href: "https://www.behance.net/gallery/208894949/2D-Explainer-Animation",
  },
];

// Get unique categories from PORTFOLIO_ITEMS
const categories = [
  "All",
  ...new Set(PORTFOLIO_ITEMS.map((item) => item.category)),
];

export default function Portfolio() {
  const [activeCategory, setActiveCategory] = useState("All");

  // Filter items based on active category
  const filteredItems =
    activeCategory === "All"
      ? PORTFOLIO_ITEMS
      : PORTFOLIO_ITEMS.filter((item) => item.category === activeCategory);

  return (
    <section className="portfolio section" id="portfolio">
      <div className="container">
        <div className="text-center">
          <span className="section-label">Portfolio</span>
          <h2 className="section-title">My Work</h2>
          <div className="divider" />
        </div>

        {/* Category Filter Buttons */}
        <div className="portfolio-categories">
          {categories.map((category) => (
            <button
              key={category}
              className={`category-btn ${activeCategory === category ? "active" : ""}`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="portfolio-grid">
          {filteredItems.map((item) => (
            <a
              href={item.href}
              className="portfolio-item"
              key={item.id}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="portfolio-thumb">
                {item.image ? (
                  <img src={item.image} alt={item.title} />
                ) : (
                  <div className="portfolio-placeholder">
                    {/* 🔗 PLACEHOLDER: Add image path in PORTFOLIO_ITEMS array */}
                    <span>+</span>
                  </div>
                )}
                <div className="portfolio-hover">
                  <span className="portfolio-item-category">
                    {item.category}
                  </span>
                  <h4 className="portfolio-item-title">{item.title}</h4>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* 🔗 PLACEHOLDER: Update href to your full portfolio page */}
        <div className="text-center" style={{ marginTop: "40px" }}>
          <a href="/portfolio-work" className="btn btn-primary">
            View Full Portfolio
          </a>
        </div>
      </div>
    </section>
  );
}
